module.exports = __webpack_public_path__ + "img/zebra.eb6191b0.png";